/**
 * Edge middleware에서 Node SSR까지 trace 문맥을 전달하기 위한 내부 헤더와,
 * 브라우저에서 요청을 식별할 때 사용하는 응답 헤더를 정의합니다.
 *
 * NOTE: RESPONSE_REQUEST_ID 값은 packages/core의 KC_REQUEST_ID_HEADER와 동일
 * Edge runtime(edgeTrace.ts)이 이 파일을 import하므로 @kc-console/core 번들 제약으로 그쪽은 리터럴을 유지
 */
export const SERVER_TRACE_HEADERS = {
  // 클라이언트가 보낸 값은 신뢰하지 않고 middleware에서 새 UUID로 덮어씁니다.
  REQUEST_ID: 'x-kc-server-trace-id',
  MIDDLEWARE_DURATION: 'x-kc-middleware-duration-ms',
  RESPONSE_REQUEST_ID: 'x-kc-request-id',
} as const;

// Kibana 스키마 변경 시 이전 로그와 구분하기 위한 버전입니다.
export const SERVER_TRACE_SCHEMA_VERSION = 2 as const;
// 잘못 구성된 Guard 체인이 로그 문서 크기를 무한히 키우지 않도록 제한합니다.
export const SERVER_TRACE_MAX_SPANS = 100;
// 샘플링되지 않은 요청도 이 시간을 넘으면 느린 요청으로 기록합니다.
export const SERVER_TRACE_DEFAULT_SLOW_THRESHOLD_MS = 1000;
// 샘플링 기본값은 100%입니다.
export const SERVER_TRACE_DEFAULT_SAMPLE_RATE = 1;
